// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__yI-0+","tooltip__arrow":"Tooltip_tooltip__arrow__8L+-f"};